export default __webpack_public_path__ + "static/media/Refresh_Miami.78a36942.svg";